import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { pure } from 'recompose';
import Loading from '../../components/Loading';
import DisclosureLayout from './components/DisclosureLayout';
import {
  DisclosureInitialData,
  DisclosureInitialDataResponse,
  mapFormDataToPostData,
  PrivatePersonDisclosureData,
} from '../../model/disclosureData';
import { isAxiosError } from '../../shared/isAxiosError';
import DisclosureErrorPage, { errorType } from '../responsePage/ErrorPage';
import { getDisclosureData, postDisclosure } from '../../shared/api/DisclosureApi';
import { SubmissionError } from 'redux-form';
import SuccessPage from '../responsePage/SuccessPage';

interface State {
  loading: boolean;
  loadError: null | errorType;
  submitError: null | errorType;
  initalData: DisclosureInitialData | null;
  success: boolean;
}

type Props = RouteComponentProps<{ id: string; type: string }>;

class Disclosure extends React.Component<Props, State> {
  state: State = {
    loading: true,
    loadError: null,
    submitError: null,
    initalData: null,
    success: false,
  };

  public async componentDidMount() {
    try {
      const data = await getDisclosureData(this.props.match.params.id);
      let data1 = data as DisclosureInitialDataResponse;
      // const data1: DisclosureInitialDataResponse = {
      //   item: {
      //     firstName: 'Max',
      //     lastName: 'Mustermann',
      //     street: 'Straße',
      //     houseNumber: '123',
      //     zipCode: '1234',
      //     city: 'Stadt',
      //     phone: 'telefon',
      //     email: 'develop@validdata.de',
      //     identityCardNumber: 'ID235a4a5s4d8adg88hj',
      //     identityCardIssuedOn: '2018-11-01',
      //     identityCardIssuedPlace: 'Place',
      //   },
      // };
      this.setState({ initalData: data1.item, loading: false, loadError: null });
    } catch (e) {
      if (isAxiosError(e)) {
        if (e.response != null) {
          const statusCode = e.response.status;
          let error: errorType;
          switch (statusCode) {
            case 403: {
              error = 'forbidden';
              break;
            }
            case 404: {
              error = 'notfound';
              break;
            }
            default: {
              error = 'unknown';
            }
          }
          this.setState({ initalData: null, loading: false, loadError: error });
        }
      }
    }
  }

  render() {
    const { loading, initalData, submitError, success } = this.state;
    let loadError = this.state.loadError;

    const disclosureId = this.props.match.params.id;

    if (success) {
      return (
        <SuccessPage
          headerTitleLanguageEntry={'disclosureSuccessTitle'}
          successTextLanguageEntry={'disclosureSuccessText'}
        />
      );
    }

    if (loading) {
      return <Loading />;
    }

    if (submitError != null) {
      return (
        <DisclosureErrorPage
          error={submitError}
          notFound={'notFoundLoadError'}
          forbidden={'forbiddenLoadError'}
          unknown={'unknownLoadError'}
        />
      );
    }
    if (initalData != null) {
      return <DisclosureLayout disclosureData={initalData} disclosureId={disclosureId} onSubmit={this.onSubmit} />;
    }

    if (loadError == null) {
      loadError = 'unknown';
    }
    return (
      <DisclosureErrorPage
        error={loadError}
        notFound={'notFoundLoadError'}
        forbidden={'forbiddenLoadError'}
        unknown={'unknownLoadError'}
      />
    );
  }

  private onSubmit = (values: PrivatePersonDisclosureData) => {
    const disclosureId = this.props.match.params.id;
    const postData = mapFormDataToPostData(values);
    return postDisclosure(disclosureId, postData)
      .then(() => {
        this.setState({ success: true, submitError: null });
      })
      .catch((e: Error) => {
        if (isAxiosError(e)) {
          if (e.response != null) {
            const statusCode = e.response.status;
            switch (statusCode) {
              case 403: {
                this.setState({ submitError: 'forbidden' });
                return;
              }
              case 404: {
                this.setState({ submitError: 'notfound' });
                return;
              }
              default: {
                break;
              }
            }
          }
        }
        throw new SubmissionError({
          _error: e.message,
        });
      });
  };
}

export default pure(Disclosure);



// WEBPACK FOOTER //
// ./src/routes/disclosure/Disclosure.tsx